import { render, staticRenderFns } from "./FoodAllergiesBlock.vue?vue&type=template&id=8d918e4e&lang=pug&"
import script from "./FoodAllergiesBlock.vue?vue&type=script&lang=js&"
export * from "./FoodAllergiesBlock.vue?vue&type=script&lang=js&"
import style0 from "./FoodAllergiesBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports